import { render, staticRenderFns } from "./CarNotesEditForm.vue?vue&type=template&id=b9ce15b6&scoped=true&"
import script from "./CarNotesEditForm.vue?vue&type=script&lang=js&"
export * from "./CarNotesEditForm.vue?vue&type=script&lang=js&"
import style0 from "./CarNotesEditForm.vue?vue&type=style&index=0&id=b9ce15b6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9ce15b6",
  null
  
)

export default component.exports